import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { HandleError, HttpErrorHandlerService } from '../http/http-error-handler.service';
import { ApiConnectorService } from '../__api/api-connector.service';
import { ConfigService } from '../___common/__config/config.service';

const HTTP_OPTIONS = {

  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  // Error handling
  private handleError: HandleError;
  private ADMIN_EMAIL = 'voyjaleas.cr@gmail.com';
  
  loadingPreview  = false;
  emailMessageToSendObj = {};

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandlerService,private apiConnector: ApiConnectorService,private configService: ConfigService) { 
    this.handleError = httpErrorHandler.createHandleError('ApiEmailService');
  }

  sendPhpEmail(NewElement: any) {
    
    let apiUrl  = this.configService.getApiUrlRefactor('emailDash');
    let phpFileName = 'sendEmail.php';
    apiUrl = apiUrl + phpFileName;

    return this.http.post<any>(apiUrl, NewElement, HTTP_OPTIONS)
      .pipe(
        catchError(this.handleError('addingNewElement', NewElement))
      );
  }

  getEmailHtmlBodyReadyToSend(){
    return this.emailMessageToSendObj;
  }

  setConfigValue(configField,value){
    this.emailMessageToSendObj[configField] = value;
  }

  // POST operation with the data entered to preview the email
  getEmailPreview(templateId: string, NewElement: any) {
    
    this.loadingPreview = true;
    let apiUrl  = this.configService.getApiUrlRefactor('emailApp');
    let phpFileName = 'emailTools.php';
    let queryParam1 = '?templateId='+templateId;

    apiUrl = apiUrl + phpFileName;
    templateId?  apiUrl = apiUrl + queryParam1 : null;

    return this.http.post<any>(apiUrl, NewElement, HTTP_OPTIONS).pipe(
      map((response) => {
        if (response.success) {
          this.emailMessageToSendObj['htmlBody'] = response.htmlBody;
          this.emailMessageToSendObj['postedData'] = response.postedData;
          // Access posted data and generated HTML
          const { postedData, htmlBody } = response;
          this.loadingPreview = false;
          return { postedData, htmlBody };
        } else {
          this.loadingPreview = false;
          throw new Error(response.message || 'Error generating email preview');
        }
      }),
      catchError(this.handleError('addingNewElement', NewElement))
    );
  }

  recoverPassword(email: string) {
    const emailObj = { email };
    return this.http.post(this.configService.getApiUrlRefactor('auth')+'recover_password.php', emailObj);
  }

  sendOmnibusProcessEmail(emailObj){
    return this.http.post(
      this.configService.getApiUrlRefactor('emailApp')+'notifyAdmin.php',
      emailObj
    ).toPromise();
  }

  getAdminEmail(){
    return this.ADMIN_EMAIL;
  }
}
